import React from 'react';

import { useGetCatalogEntryAnalogsQuery } from '../../../entities/productAnalogs/api/productAnalogsApi';
import type { CatalogEntry } from '../../../entities/productAnalogs/model/types';
import { pluralRu } from '../../ui/DatePicker';
import { ProductRow } from './ProductRow';
import styles from './ProductAnalogsTable.module.scss';
import { Waiting } from '../../ui/Waiting/Waiting';

const CARD_INDENT = 22;

interface AnalogsGroupProps {
    entryId: string;
    count: number;
    selectedId: string | null;
    columnWidths: number[];
    onSelect: (entry: CatalogEntry) => void;
}

export function AnalogsGroup({ entryId, count, selectedId, columnWidths, onSelect }: AnalogsGroupProps) {
    const { data: analogs = [], isLoading } = useGetCatalogEntryAnalogsQuery(entryId);

    const [product, links, kind, project, date] = columnWidths;
    const width = (value: number | undefined) => (value ? { width: value } : undefined);

    return (
        <tr className={styles.analogsGroup}>
            <td />
            <td colSpan={7}>
                <div className={styles.group}>
                    <span className={styles.trunk} aria-hidden="true" />

                    <div className={styles.groupHead}>
                        Найдено: {count} {pluralRu(count, ['аналог', 'аналога', 'аналогов'])}
                    </div>

                    {isLoading ? (
                        <Waiting text='Загружаем аналоги…' />
                    ) : (
                        <table className={styles.inner}>
                            <colgroup>
                                <col className={styles.colBranch} />
                                <col style={width(product ? product - CARD_INDENT : undefined)} />
                                <col style={width(links)} />
                                <col style={width(kind)} />
                                <col style={width(project)} />
                                <col style={width(date)} />
                                <col />
                            </colgroup>
                            <tbody>
                                {analogs.map((analog) => (
                                    <ProductRow
                                        key={analog.id}
                                        entry={analog}
                                        nested
                                        selected={selectedId === analog.id}
                                        onSelect={onSelect}
                                    />
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </td>
        </tr>
    );
}